module.exports = __webpack_public_path__ + "img/offline.15c3ae93.svg";